/*
*   List of Action IDs that should be passed from accreditation.reducer.js to settings.reducer.js
 */

export const IDS = {
    accSettings: 'accSettings',

    // components:
    accreditationSettingsFrameworkDetails:        'accreditationSettingsFrameworkDetails',

    accreditationSettingsHeadOffices:             'accreditationSettingsHeadOffices',
    accreditationSettingsSiteLocations:           'accreditationSettingsSiteLocations',

    accreditationSettingsRequirementDetails:          'accreditationSettingsRequirementDetails',

    accreditationSettingsHeadOfficeDocsGrid:      'accreditationSettingsHeadOfficeDocsGrid',
    accreditationSettingsAssessmentDetails:       'accreditationSettingsAssessmentDetails',
    accreditationSettingsAssessmentHeadOffice:    'accreditationSettingsAssessmentHeadOffice',

    //paths
    headOfficesGrid:                    'headOfficesGrid',
    siteLocationsGrid:                  'siteLocationsGrid',

    evidence:                           'evidence',
    evidenceGrid:                       'evidenceGrid',
    evidenceDetails:                    'evidenceDetails',
    evidenceRequirementsGrid:           'evidenceRequirementsGrid',
    evidenceApplicableHeadOfficesGrid:  'evidenceApplicableHeadOfficesGrid',
    evidenceApplicableSites:            'evidenceApplicableSites',
    evidenceApplicableSitesGrid:        'evidenceApplicableSitesGrid',
    evidenceImports:                    'evidenceImports',
    evidenceImportsGrid:                'evidenceImportsGrid',

    requirements:                       'requirements',
    requirementsImports:                'requirementsImports',
    requirementsImportsGrid:            'requirementsImportsGrid',

    sloRequiredDocs:                    'sloRequiredDocs',
    sloRequiredDocsGrid:                'sloRequiredDocsGrid',
    sloRequiredDocDetails:              'sloRequiredDocDetails',
    sloRequiredDocSectionsGrid:         'sloRequiredDocSectionsGrid',
    sloRequiredDocsImports:             'sloRequiredDocsImports',
    sloRequiredDocsImportsGrid:         'sloRequiredDocsImportsGrid',

    assessmentDetails:                  'assessmentDetails',
    assessmentHeadOffice:               'assessmentHeadOffice',
    assessmentHeadOfficesGrid:          'assessmentHeadOfficesGrid',

    // states
    app_accreditation_add_scheme:                                   'app.accreditation.add-scheme',

    // tab states:
    app_accreditation_scheme_settings:                              'app.accreditation.scheme.settings',
    app_accreditation_scheme_settings_dashboard:                    'app.accreditation.scheme.settings.dashboard',

    app_accreditation_scheme_settings_framework_details:            'app.accreditation.scheme.settings.framework-details',

    app_accreditation_scheme_settings_enabled:                      'app.accreditation.scheme.settings.enabled',
    app_accreditation_scheme_settings_enabled_head_offices:         'app.accreditation.scheme.settings.enabled.head-offices',
    app_accreditation_scheme_settings_enabled_site_locations:       'app.accreditation.scheme.settings.enabled.site-locations',

    app_accreditation_scheme_settings_requirements:                 'app.accreditation.scheme.settings.requirements',
    app_accreditation_scheme_settings_requirements_list:            'app.accreditation.scheme.settings.requirements.list',
    app_accreditation_scheme_settings_requirements_imports:         'app.accreditation.scheme.settings.requirements.imports',

    app_accreditation_scheme_settings_evidence:                     'app.accreditation.scheme.settings.evidence',
    app_accreditation_scheme_settings_evidence_list:                'app.accreditation.scheme.settings.evidence.list',
    app_accreditation_scheme_settings_evidence_add:                 'app.accreditation.scheme.settings.evidence.add',
    app_accreditation_scheme_settings_evidence_details:             'app.accreditation.scheme.settings.evidence.details',
    app_accreditation_scheme_settings_evidence_applicable_sites:    'app.accreditation.scheme.settings.evidence.applicable-sites',
    app_accreditation_scheme_settings_evidence_imports:             'app.accreditation.scheme.settings.evidence.imports',

    app_accreditation_scheme_settings_slo_required_docs:            'app.accreditation.scheme.settings.slo-required-docs',
    app_accreditation_scheme_settings_slo_required_docs_list:       'app.accreditation.scheme.settings.slo-required-docs.list',
    app_accreditation_scheme_settings_slo_required_docs_add:        'app.accreditation.scheme.settings.slo-required-docs.add',
    app_accreditation_scheme_settings_slo_required_docs_details:    'app.accreditation.scheme.settings.slo-required-docs.details',
    app_accreditation_scheme_settings_slo_required_docs_imports:    'app.accreditation.scheme.settings.slo-required-docs.imports',
};